import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import DetailsPage from "../components/DetailsPage";

function SanitaryDetails() {
  const [bookingDetails, setBookingDetails] = useState([]);
  const { sanitaryId, sanitaryName } = useParams();
  const [totalAmount, setTotalAmount] = useState("0.00");

  useEffect(() => {
    const fetchSanitaryDetails = async () => {
      try {
        const formData = new FormData();
        formData.append("sanitary_id", sanitaryId);
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/sanitary_reports`,
          {
            method: "POST",
            body: formData,
          }
        );
        const data = await response.json();
        console.log("API Response:", data); // Debug log
        const mappedData = data.report_list.map((item) => {
          console.log("Processing item:", item); // Debug log
          return {
            bookingId: item.booking_id || "",
            serviceDate: item.service_date || "",
            bookedOn: item.booked_on || "",
            customerName: item.customer_name || "",
            address: item.address || "",
            amount: item.amount || "0",
          };
        });
        console.log("Mapped Data:", mappedData); // Debug log
        setBookingDetails(mappedData);
        setTotalAmount(data.total_amount || "0.00");
      } catch (error) {
        console.error("Error fetching sanitary details:", error);
      }
    };
    fetchSanitaryDetails();
  }, [sanitaryId]);

  const columns = [
    { field: "bookingId", header: "Booking ID" },
    { field: "serviceDate", header: "Service Date" },
    { field: "bookedOn", header: "Booked On" },
    { field: "customerName", header: "Customer Name" },
    { field: "address", header: "Address" },
    { field: "amount", header: "Amount" },
  ];

  const handleRowClick = (row) => {
    console.log("Row clicked:", row);
  };

  const handleDateFilterChange = (startDate, endDate, filteredData) => {
    const total = filteredData.reduce((sum, item) => {
      const amount = parseFloat(item.amount) || 0;
      return sum + amount;
    }, 0);
    setTotalAmount(total.toFixed(2));
  };

  return (
    <DetailsPage
      title={`${sanitaryName} Bookings`}
      backPath="/sanitary"
      columns={columns}
      data={bookingDetails}
      onRowClick={handleRowClick}
      totalAmount={totalAmount}
      dateField="bookedOn"
      showTotalAmount={true}
      onDateFilterChange={handleDateFilterChange}
    />
  );
}

export default SanitaryDetails;
